import React, { useState } from 'react'
import styled from 'styled-components'
import { XL } from '@zendeskgarden/react-typography'
import { Paragraph, Well } from '@zendeskgarden/react-notifications'
import MaintenanceModal from './MaintenanceModal'
import { Modal, Close } from '@zendeskgarden/react-modals'
import { Button } from '@zendeskgarden/react-buttons'
import { Row } from '@zendeskgarden/react-grid'
import StatusIcon from './StatusIcon'

const BannerWell = styled(Well)`
  width: 950px
  justify-content: space-between
  background-color: #f8f9f9
`

const StyledModalTitle = styled.div`
  overflow: wrap
  max-width: 95%
  text-align: left
`

const StyledModalIconDiv = styled.div`
  padding-right: 5px
  padding-top: 1px
  padding-left: 10px
`

const Spacer = styled.div`
  padding-right: 4px
`

const MaintenanceBanner = ({ maintenanceIncidents, inTimezone }) => {
  const [modalIncident, setModalIncident] = useState(null)

  function modalTrigger(incident, inTimezone) {
    const onModalClose = () => {
      setModalIncident(null)
    }

    return (
      <div>
        <Row>
          <StyledModalIconDiv>
            <StatusIcon status={'maintenance'} />
          </StyledModalIconDiv>
          <StyledModalTitle>
            {incident.attributes.name}
          </StyledModalTitle>
          <Spacer/>
          <Button onClick={() => { setModalIncident(incident) }} link>
            View Details
          </Button>
        </Row>
        {
          modalIncident && <Modal onClose={onModalClose} large animate>
            <MaintenanceModal
              key={`${modalIncident.id.toString()}`}
              incident={modalIncident}
              inTimezone={inTimezone}
            >
            </MaintenanceModal>
            <Close aria-label="Close modal" />
          </Modal>
        }
      </div>
    )
  }

  return (
    <BannerWell>
      <XL>Maintenance scheduled on Zendesk services</XL>
      {maintenanceIncidents.map(incident => (
        <Paragraph key={incident.id}>
          {modalTrigger(incident, inTimezone)}
        </Paragraph>
      ))}
    </BannerWell>
  )
}

export default MaintenanceBanner
